// extracted by mini-css-extract-plugin
module.exports = {"general_section":"Search_general_section__iCmWf","container_inputs":"Search_container_inputs__DaAsZ"};